











































































































import Global from '@/common/global.js'
import CheckBox from '@/views/atoms/CheckBox.vue'
import PopupFileUpload from '@/views/template/PopupFileUpload.vue'
import store from '@/store'
import PopupVehicleInformationComment from '@/views/template/PopupVehicleInformationComment.vue'
import GreenButton from '@/views/atoms/GreenButton.vue'
import ApiClient from '@/common/api'
import PopupAgentCommentAdd from '@/views/template/PopupAgentCommentAdd.vue'

export default
  components: {
    CheckBox
    PopupFileUpload
    PopupVehicleInformationComment
    GreenButton
    PopupAgentCommentAdd
  }

  data: () ->
    id: 0
    showCommentAdd: false,
    isShowPopup: []
    displayItems: store.getters.defaultSetPartnerDisplayItems
    downloadId: ''
    downloadIds: []
    downloadCheck: false
    partnerLabel: Global.partnerLabel()
    booking: ''
    shipper_name: ''
    
  props:
    list:
      type: Array
      default: []
  methods: {
    getStatusLabel: (code) ->
      status = Global.showStatusEn()
      return status[code].name
    showPopup: (id, index) ->
      @id = id
      @$set(@isShowPopup, index, true)
    closePopup: (index) ->
      @$set(@isShowPopup, index, false)
    checkBox: (num) ->
      if num == "0"
        return false
      return true
    getList: (e) ->
      @$emit('click')

    downloadChange: (e) ->
      @downloadId = Number(e)
    downloadChecked: (e) ->
      if e
        ids = @downloadIds.map (el) -> el.id
        index = ids.indexOf(@downloadId)
        if index < 0
          @downloadIds.push('id': @downloadId)
      else
        ids = @downloadIds.map (el) -> el.id
        index = ids.indexOf(@downloadId)
        @downloadIds.splice(index, 1)
    download: () ->
      param =
        download_ids: @downloadIds
      api = new ApiClient()
      data = await api.post('/download/all', param)
      if data.file.data != ''
        fileData = atob(data.file.data.replace(/^.*,/, ''))
        buffer = new Uint8Array(fileData.length)
        for i in [0..fileData.length]
          buffer[i] = fileData.charCodeAt(i)
        file = new File([buffer.buffer], data.file.name, {type: 'application/zip'});
        blob = new Blob([file], { type: 'application/zip' })
        link = document.createElement('a')
        link.download = data.file.name
        link.href = URL.createObjectURL(blob)
        link.click()
    clickDownloadCheck: (list) ->
      if @downloadCheck
        @downloadCheck = false
      else
        @downloadCheck = true
      for row, index in list
        @downloadChange(row.id)
        @downloadChecked(@downloadCheck)
    clickComment: (id, booking, shipper_name) ->
      @id = id
      @booking = booking
      @shipper_name = shipper_name
      @showCommentAdd = true
    close_comment_add: (e) ->
      @showCommentAdd = false
    commentSave: () ->
      @close_comment_add()
      @getList()
  }
